import React, { useState } from "react";
import { FaPaperPlane, FaUser, FaEnvelope, FaPhone, FaTag, FaComment, FaWhatsapp } from "react-icons/fa";
import api from "../../services/axiosInstance";

const EmailForm = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
    privacy: false,
  });

  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({ ...form, [name]: type === "checkbox" ? checked : value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Envoi en cours...");

    try {
      const res = await api.post("/send-email", {
        to: "contact@ctrl-plusx.com", 
        subject: form.subject || "Message du formulaire",
        message: `
Nom : ${form.name}
Email : ${form.email}
Téléphone : ${form.phone}
Sujet : ${form.subject}
---
${form.message}
`,
      });

      setStatus(res.data.message);
      setForm({
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
        privacy: false,
      });
    } catch (err) {
      console.error(err);
      setStatus("Échec de l'envoi du message.");
    }
  };

  const contactWhatsAppForm = () => {
    const text = `Nom: ${form.name}%0AEmail: ${form.email}%0ATéléphone: ${form.phone}%0ASujet: ${form.subject}%0A%0AMessage:%0A${form.message}`;
    window.open(`https://wa.me/213000000000?text=${text}`);
  };

  return (
   <div className="max-w-4xl mx-auto mt-10 p-4">
  <div className="glassmorphism-form bg-white bg-opacity-90 backdrop-blur-sm rounded-3xl shadow-2xl p-8 md:p-10 border border-white border-opacity-30">

    {/* Title */}
    <div className="text-center mb-10">
      <h3 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4 flex items-center justify-center">
        <FaPaperPlane className="mr-3 text-blue-600 text-2xl md:text-3xl" />
        Envoyez-nous un message
      </h3>
      <p className="text-gray-600 text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
        Remplissez le formulaire et nous vous répondrons rapidement
      </p>
    </div>

    {/* Form */}
    <form onSubmit={handleSubmit} className="space-y-8">

      {/* Name & Email */}
      <div className="grid md:grid-cols-2 gap-6 md:gap-8">
        <div className="space-y-3">
          <label className="block text-sm font-semibold text-gray-800 mb-2 flex items-center">
            <FaUser className="text-blue-500 mr-2" /> Nom complet *
          </label>
          <input
            type="text"
            name="name"
            required
            value={form.name}
            onChange={handleChange}
            className="w-full px-5 py-4 border-2 border-blue-100 rounded-xl focus:border-blue-400 focus:ring-4 focus:ring-blue-50 bg-white transition-all duration-200 placeholder-gray-400"
            placeholder="Votre nom et prénom"
          />
        </div>

        <div className="space-y-3">
          <label className="block text-sm font-semibold text-gray-800 mb-2 flex items-center">
            <FaEnvelope className="text-green-500 mr-2" /> Email *
          </label>
          <input
            type="email"
            name="email"
            required
            value={form.email}
            onChange={handleChange}
            className="w-full px-5 py-4 border-2 border-green-100 rounded-xl focus:border-green-400 focus:ring-4 focus:ring-green-50 bg-white transition-all duration-200 placeholder-gray-400"
            placeholder="votre@email.com"
          />
        </div>
      </div>

      {/* Phone & Subject */}
      <div className="grid md:grid-cols-2 gap-6 md:gap-8">
        <div className="space-y-3">
          <label className="block text-sm font-semibold text-gray-800 mb-2 flex items-center">
            <FaPhone className="text-purple-500 mr-2" /> Téléphone
          </label>
          <input
            type="tel"
            name="phone"
            value={form.phone}
            onChange={handleChange}
            className="w-full px-5 py-4 border-2 border-purple-100 rounded-xl focus:border-purple-400 focus:ring-4 focus:ring-purple-50 bg-white transition-all duration-200 placeholder-gray-400"
            placeholder="Votre numéro"
          />
        </div>

        <div className="space-y-3">
          <label className="block text-sm font-semibold text-gray-800 mb-2 flex items-center">
            <FaTag className="text-orange-500 mr-2" /> Sujet
          </label>
          <select
            name="subject"
            value={form.subject}
            onChange={handleChange}
            className="w-full px-5 py-4 border-2 border-orange-100 rounded-xl focus:border-orange-400 focus:ring-4 focus:ring-orange-50 bg-white transition-all duration-200 text-gray-700"
          >
            <option value="" className="text-gray-400">Choisir un sujet</option>
            <option value="formation">Information sur les formations</option>
            <option value="consultation">Demande de consultation</option>
            <option value="projet">Projet personnalisé</option>
            <option value="autre">Autre</option>
          </select>
        </div>
      </div>

      {/* Message */}
      <div className="space-y-3">
        <label className="block text-sm font-semibold text-gray-800 mb-2 flex items-center">
          <FaComment className="text-blue-500 mr-2" /> Message *
        </label>
        <textarea
          name="message"
          required
          rows="5"
          value={form.message}
          onChange={handleChange}
          className="w-full px-5 py-4 border-2 border-blue-100 rounded-xl focus:border-blue-400 focus:ring-4 focus:ring-blue-50 bg-white transition-all duration-200 placeholder-gray-400 resize-none"
          placeholder="Décrivez votre demande en détail..."
        ></textarea>
      </div>
    </form>

    {/* Status Message */}
    {status && (
      <p className="mt-8 text-center text-gray-700 font-medium px-4">{status}</p>
    )}
  </div>
</div>
  );
};

export default EmailForm;
